(() => {
  const root = document.documentElement;
  let observer;
  const observeFooter = () => {
    observer?.disconnect();
    root.removeAttribute('data-burd-footer-controls-visible');
    const controls = document.querySelector('.bl-footer--compact .bl-footer-bottom');
    if (!controls || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(([entry]) => {
      root.toggleAttribute('data-burd-footer-controls-visible', entry.isIntersecting);
    }, { rootMargin: '0px 0px 100px 0px' });
    observer.observe(controls);
  };
  observeFooter();
  document.addEventListener('shopify:section:load', observeFooter);
  document.addEventListener('shopify:section:unload', observeFooter);
})();
